import { render, staticRenderFns } from "./printOrderModal.vue?vue&type=template&id=588094cb&"
import script from "./printOrderModal.vue?vue&type=script&lang=js&"
export * from "./printOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports